import { z } from "zod";

/**
 * Delivery Cues (CONTEXT.md). A pause sits after a Block and becomes exact
 * silence in the stitcher; a tone is one word that becomes an eleven_v3 audio
 * tag in front of the Block. These lists are the single definition; the
 * server's constants (seconds per pause) key off them.
 */
export const PAUSE_KINDS = ["none", "short", "medium", "long"] as const;
export const PauseKindSchema = z.enum(PAUSE_KINDS);
export type PauseKind = z.infer<typeof PauseKindSchema>;

export const TONES = [
  "whispers",
  "sighs",
  "excited",
  "sarcastic",
  "curious",
  "laughs",
  "nervous",
  "serious",
] as const;
export const ToneSchema = z.enum(TONES);
export type Tone = z.infer<typeof ToneSchema>;
